import { format, isValid, parseISO } from 'date-fns';

export function formatString(template, values) {
    return template.replace(/{(\w+)}/g, (match, key) => values[key] || '');
}

export function cutText(text, maxLength) {
    if (text.length > maxLength) {
        return text.slice(0, maxLength) + '...';
    }
    return text;
}

export function formatDate(isoString) {
    if (!isoString) return '—';
    const d = parseISO(isoString);
    return isValid(d) ? format(d, 'dd.MM.yyyy') : isoString;
}

export function formatDateTime(isoString) {
    if (!isoString) return '—';
    const d = parseISO(isoString);
    return isValid(d) ? format(d, 'dd.MM.yyyy HH:mm') : isoString;
}
